<template>
  <v-layout align-center
            class="mb-2">
    <v-flex xs6>
      <h1>{{sectionName}}</h1>
    </v-flex>
    <v-flex xs3>
      {{ totalItems }} {{sectionName.toLowerCase()}} cadastrados
    </v-flex>
    <v-flex v-if="items.length > 0"
            xs3
            class="text-xs-center"
    >
      <span>Exibindo {{ showingStart }} - {{ showingEnd }}</span>
      <v-btn icon @click="$emit('update:pageNumber', pageNumber-1)"
             :disabled="pageNumber <= 1">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn icon @click="$emit('update:pageNumber', pageNumber+1)"
             :disabled="pageNumber >= totalPages">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>

export default {
  name: 'HeaderForListComponent',
  props: ['sectionName', 'items', 'totalItems', 'totalPages', 'itemsPerPage', 'pageNumber'],
  data() {
    return {};
  },
  computed: {
    showingStart() {
      return (this.pageNumber - 1 === 0) ? 1 : (this.pageNumber - 1) * this.itemsPerPage;
    },
    showingEnd() {
      if (this.totalPages === this.pageNumber) {
        return this.totalItems;
      }
      return (this.pageNumber * this.itemsPerPage);
    },
  },
  watch: {
    pageNumber() {
      this.$emit('loadPage', this.pageNumber);
    },
  }
};
</script>

<style scoped lang="scss">
</style>
